<template>
  <div class="flex">
    <div class="match-pair">
      <div class="a-vs-c-host">
        <div class="img-wrap">
          <img :src="match.HomeTeamLogo" :alt="match.HomeTeamShort">
        </div>
        <span v-if="!isMobileDesign">{{match.HomeTeam}}</span>
        <span v-else>{{match.HomeTeamShort}}</span>
      </div>
      <hr>
      <div class="a-vs-c-guest">
          <div class="img-wrap">
            <img :src="match.AwayTeamLogo" :alt="match.AwayTeamShort">
          </div>
          <span v-if="!isMobileDesign">{{match.AwayTeam}}</span>
          <span v-else>{{match.AwayTeamShort}}</span>
        </div>
      </div>
      <div class="match-info">
        <p>{{$t('round')}}: <span>{{roundNumber}}</span></p>
        <p>{{$t('starts_in')}}: <span>{{timeToStart}}</span></p>
      </div>
    </div>
</template>
<script>
import { eventBus } from '@/main.js'
import EventConstants from '@/constants/Events'
import TimeFormatter from '@/mixins/TimeFormatter'

export default {
  mixins: [TimeFormatter],
  props: {
    event: Object,
    activeEvent: Object,
    numberOfSlide: Number,
    roundLength: Number,
    isMobileDesign: Boolean
  },
  data () {
    return {
      timeToStart: ''
    }
  },
  computed: {
    match: function () {
      return this.event.Matches[0]
    },
    roundNumber: function () {
      return this.event.EventID % 1000
    },
    startingTime: function () {
      return Math.round(this.timeToStart)
    }
  },
  methods: {
    onShowTimer: function (data) {
      let secondstoend = Math.round(data + this.numberOfSlide * this.roundLength)
      this.timeToStart = this.secondsToTime(secondstoend)
    }
  },
  created: function () {
    eventBus.$on(EventConstants.VSOCCER_SHOW_TIMER, this.onShowTimer)
  },
  beforeDestroy () {
    eventBus.$off(EventConstants.VSOCCER_SHOW_TIMER, this.onShowTimer)
  }
}
</script>
